import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';

var SelectOption = function (_a) {
  var placeholder = _a.placeholder,
    value = _a.value,
    children = _a.children,
    rest = __rest(_a, ["placeholder", "value", "children"]);
  if (placeholder) {
    return /*#__PURE__*/React__default__default.createElement("option", {
      key: "placeholder",
      value: value,
      style: {
        display: 'none'
      }
    }, placeholder);
  }
  return /*#__PURE__*/React__default__default.createElement("option", __assign({
    value: value
  }, rest), children || value);
};
SelectOption.displayName = 'SelectOption';
SelectOption.defaultProps = {
  placeholder: null,
  children: null
};
SelectOption.propTypes = {
  value: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]).isRequired,
  children: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
  placeholder: PropTypes__default.string
};

export { SelectOption as default };
